import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.SUPABASE_ANON_KEY;

// Custom storage adapter that only keeps the token in memory
// This prevents cross-tab persistence but is completely immune to local file harvesting
// and prevents tokens from sitting in localStorage indefinitely.
const memoryStorage = {
  items: new Map<string, string>(),
  getItem: (key: string) => memoryStorage.items.get(key) || null,
  setItem: (key: string, value: string) => { memoryStorage.items.set(key, value); },
  removeItem: (key: string) => { memoryStorage.items.delete(key); }
};

export const supabase = supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
}) : null;

export const isSupabaseConfigured = !!supabase;
